module.exports = __webpack_public_path__ + "static/media/whitearrow.41cf1e4b.svg";